import { Signal } from "@/data/util/Signal";

export const globalEvents = {
    OnSessionExpired: new Signal(),
};
